import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface DeleteConfirmationDialogProps {
  open: boolean;
  projectName: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  projectName,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-confirmation-dialog-title"
      aria-describedby="delete-confirmation-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle 
        id="delete-confirmation-dialog-title"
        sx={{ pb: 1 }}
      >
        Delete Project
      </DialogTitle>
      <DialogContent sx={{ pt: 1, pb: 2 }}>
        <DialogContentText 
          id="delete-confirmation-dialog-description"
          sx={{ mb: 0 }}
        >
          Are you sure you want to delete "{projectName}"? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pt: 0, pb: 2, px: 3 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} autoFocus variant="contained" color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
